module.exports = __webpack_public_path__ + "img/list.09a6ff16.png";